import { IdNameModel } from "./IdNameModel"

export class Photo {
    public static Create(obj: Photo) {
        return Object.assign(new Photo(), obj)
    }
    id: number = 0
    title: string = ''
    description: string = ''
    urlBig: string = ''
    urlMedium: string = ''
    urlSmall: string = ''
    get hasUsageStats() {
        return this.usedInTours?.length > 0 || this.usedInCountries?.length > 0 || this.usedInWidgets?.length > 0
    }
    usedInTours: IdNameModel[] = []
    usedInCountries: IdNameModel[] = []
    usedInWidgets: IdNameModel[] = []
}
